import './FormOnGradient.scss';

class FormOnGradient {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['FormOnGradient'] = FormOnGradient;
export default FormOnGradient;
